import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
import { get } from "lodash";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { Suspense, useMemo } from "react";
import Loader from "../../components/Loader";
import constants from "../../utils/constants";
import classNames from "classnames";
import { isWebView } from "../../utils";
import { t } from "i18next";
var getComponent = function getComponent(currentPageName) {
  var _component = null;
  switch (currentPageName) {
    case constants.SETTINGS.NOTIFICATIONS:
      _component = import("../../components/NotificationSettings");
      break;
    case constants.SETTINGS.AUTOMATED_SHARING:
      _component = import("../../components/AutomatedShare");
      break;
    case constants.SETTINGS.USER_GROUPS:
      _component = import("../../components/UserGroupManagement");
      break;
    case constants.SETTINGS.WORKLIST_TAGS:
      _component = import("../../components/WorklistTagsSetting");
      break;
    case constants.SETTINGS.FORM_TEMPLATES:
      _component = import("../../components/FormSettings");
      break;
    case constants.SETTINGS.WORKSPACE_MANAGEMENT:
      _component = import("../../components/WorkspaceManagement");
      break;
    case constants.SETTINGS.SITE_MANAGEMENT:
      _component = import("../../components/WorkspaceManagement");
      break;
    case constants.SETTINGS.REPORT_TEMPLATE:
      _component = import("../../components/ReportTemplate");
      break;
    case constants.SETTINGS.GATEWAY:
      _component = import("../../components/GatewayIndicator");
      break;
    case constants.SETTINGS.MODALITY_CONNECT:
      _component = import("../../components/ConnectModality");
      break;
    case constants.SETTINGS.DISK_MANAGEMENT:
      _component = import("../../components/DiskManagement");
      break;
    case constants.SETTINGS.REMOTE_ACCESS:
      _component = import("../../components/RemoteAccess");
      break;
    case constants.SETTINGS.LICENSE_MANAGER:
      _component = import("../../components/LicenseManager");
      break;
    case constants.SETTINGS.SCAN_TO_CONNECT:
      _component = import("../../components/ScanToConnect");
      break;
    case constants.SETTINGS.CUSTOM_TAGS_MANAGEMENT:
      _component = import("../../components/CustomTagsManagement");
      break;
    case constants.SETTINGS.LETTER_TEMPLATE:
      _component = import("../../components/LetterTemplates");
      break;
    default:
      _component = null;
  }
  return dynamic(function () {
    return _component;
  }, {
    ssr: false,
    loading: function loading() {
      return /*#__PURE__*/React.createElement(Loader, {
        size: "medium",
        label: "".concat(t("loading_key"), "...")
      });
    }
  });
};
var SettingsPage = function SettingsPage(props) {
  var pageName = props.pageName,
    onChangeSetting = props.onChangeSetting;
  var router = useRouter();
  var currentPageName = pageName || get(router, ["query", "params", "0"], "");
  var DynamicComponent = useMemo(function () {
    return getComponent(currentPageName);
  }, [currentPageName]);
  var onChangeSettingPage = function onChangeSettingPage(_pageName, pageNo) {
    router.replace("/settings/".concat(_pageName).concat(pageNo ? "/" + pageNo : ""), undefined, {
      shallow: true
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("dark:bg-gray-900 sm:bg-gray-200 sm:dark:bg-gray-800 w-full flex flex-col h-full items-center justify-center overflow-hidden", {
      "pt-6": isWebView()
    })
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: "".concat(t("loading_key"), "...")
  }, /*#__PURE__*/React.createElement(DynamicComponent, {
    pageName: currentPageName,
    onChangeSetting: onChangeSetting || onChangeSettingPage
  })));
};
export default SettingsPage;
export function getStaticProps() {
  return _getStaticProps.apply(this, arguments);
}
function _getStaticProps() {
  _getStaticProps = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          return _context.a(2, {
            // Passed to the page component as props
            props: {
              hideMenu: true
            }
          });
      }
    }, _callee);
  }));
  return _getStaticProps.apply(this, arguments);
}
export var getStaticPaths = function getStaticPaths() {
  return {
    paths: [],
    //indicates that no page needs be created at build time
    fallback: "blocking" //indicates the type of fallback
  };
};